import React, { Fragment, useState } from 'react';
import DialogComponent from '../common/Dialog/DialogComponent';
import ContentAgreement from './ContentAgreement';
import { useTranslation } from 'react-i18next';

const About = () => {
  const copyrightYears = '2018 - ' + new Date().getFullYear();
  const [contentAgreement, setContentAgreement] = useState(false);

  const handleContentAgreement = () => setContentAgreement(true);
  const closeContentAgreement = () => setContentAgreement(false);

  const { t } = useTranslation();
  const tc = e => t(`about:${e}`);

  return (
    <Fragment>
      <div className="modal-header">
        <h3 className="modal-title">
          {tc('ABOUT_TITLE')} {tc('PLANNING_MAESTRO')}
        </h3>
      </div>
      <div className="modal-body">Version: PROJECT_VERSION</div>
      <div className="modal-footer copyright-about">
        <div>
          <h5>
            {tc('ABOUT_COPYRIGHT_PREFIX')} {copyrightYears} {tc('ABOUT_COPYRIGHT_SUFFIX')}
          </h5>
          <h6>{tc('ABOUT_COPYRIGHT_CONTENT')}</h6>
          <h6>{tc('ABOUT_EULA')}</h6>
          <a href="#" className="eula-link" onClick={handleContentAgreement}>
            {' '}
            {tc('ABOUT_EULA_TITLE')}
          </a>
        </div>
        <DialogComponent open={contentAgreement} handleClose={closeContentAgreement} className="react-dialog">
          <ContentAgreement />
        </DialogComponent>
      </div>
    </Fragment>
  );
};

export default About;